import React, { useState } from "react";
import { Button, Form, Input, Tabs } from "antd";
import {
    LockOutlined,
    MobileOutlined,
    SafetyCertificateOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { MyLink, Send } from "./login";
import { lib } from "react-single-app";
import md5 from "md5";

export function PcLoginPanel({ role, loginSuccess }) {
    let [mobile, setMobile] = useState("");
    function login(type, formData) {
        const { host } = window.location;
        let url = `${lib.getParam("host") || ""}/ucenter-account/${
            lib.config.webToken == "admin" ? "admin" : "customer"
        }/${type}`;
        const { password } = formData;
        let data;
        if (type === "login") {
            data = {
                ...formData,
                isEncrypt: true,
                password: md5(password),
                domain: host,
                loginIdentity: role,
            };
        } else {
            data = { ...formData, domain: host, loginIdentity: role };
        }
        lib.request({
            url,
            data,
            needMask: true,
            success: res => {
                loginSuccess({ ...res, loginIdentity: role });
                upLoginLog(formData.userName || formData.mobile, "登录成功");
            },
            fail(res) {
                upLoginLog(formData.userName || formData.mobile, "登录失败");
            },
        });
    }

    /**
     * 上传登录日志
     */
    function upLoginLog(userName, message) {
        pin = md5(userName);
        try {
            getJdEid(function (eid, fp, udfp) {
                lib.request({
                    url: "/ares-web/channelBusinessLog/upload",
                    data: {
                        type: "login",
                        businessJson: JSON.stringify({ message: message }),
                        deviceId: eid,
                        timeStamp: new Date().getTime(),
                        ip: returnCitySN.cip,
                    },
                });
            });
        } catch (e) {}
    }
    return (
        <Tabs
            defaultActiveKey="1"
            tabBarStyle={{ ":before": { borderBottom: "rgba(0, 0, 0, 0.06)" } }}>
            <Tabs.TabPane tab="用户名登录" key="1">
                <Form name="type1" onFinish={data => login("login", data)}>
                    <Form.Item
                        name="userName"
                        rules={[{ required: true, message: "请输入用户名" }]}>
                        <Input
                            size="large"
                            placeholder="用户名"
                            prefix={<UserOutlined style={{ color: "#999" }} />}
                        />
                    </Form.Item>
                    <Form.Item name="password" rules={[{ required: true, message: "请输入密码" }]}>
                        <Input.Password
                            size="large"
                            placeholder="密码"
                            prefix={<LockOutlined style={{ color: "#999" }} />}
                        />
                    </Form.Item>
                    <MyLink role={role} />
                    <Form.Item>
                        <Button type="primary" size="large" htmlType="submit">
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab="验证码登录" key="2">
                <Form
                    name="type2"
                    onFinish={data => login("smsLogin", data)}
                    onFinishFailed={data => console.log(data)}>
                    <Form.Item
                        name="mobile"
                        validateTrigger={["onChange", "onSubmit", "onBlur"]}
                        rules={[
                            {
                                required: true,
                                message: "请输入手机号",
                            },
                            {
                                pattern: /^\d{11}$/,
                                message: "手机号码格式错误",
                                validateTrigger: ["onBlur", "onSubmit"],
                            },
                        ]}>
                        <Input
                            size="large"
                            placeholder="手机号"
                            prefix={<MobileOutlined style={{ color: "#999" }} />}
                            onChange={e => setMobile(e.target.value)}
                            maxLength={11}
                        />
                    </Form.Item>
                    <div className="code">
                        <Form.Item
                            name="code"
                            rules={[
                                {
                                    required: true,
                                    message: "请输入验证码",
                                },
                                {
                                    pattern: /^\d{0,6}$/,
                                    message: "验证码格式错误",
                                },
                            ]}>
                            <Input
                                size="large"
                                placeholder="验证码"
                                prefix={<SafetyCertificateOutlined style={{ color: "#999" }} />}
                            />
                        </Form.Item>
                        <Send data={{ mobile, type: "LOGIN" }} />
                    </div>
                    <MyLink role={role} />
                    <Form.Item>
                        <Button type="primary" size="large" htmlType="submit">
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </Tabs.TabPane>
        </Tabs>
    );
}
